__turbopack_context__.v({
  "avatarContainer": "AvatarComponent-module-scss-module__u4GvNW__avatarContainer",
  "avatarWithBadge": "AvatarComponent-module-scss-module__u4GvNW__avatarWithBadge",
  "badge": "AvatarComponent-module-scss-module__u4GvNW__badge",
  "customAvatar": "AvatarComponent-module-scss-module__u4GvNW__customAvatar",
  "large": "AvatarComponent-module-scss-module__u4GvNW__large",
  "small": "AvatarComponent-module-scss-module__u4GvNW__small",
});
